(function () {
  'use strict';

  function mediaItems(section) {
    return Array.prototype.slice.call(section.querySelectorAll('[data-product-single-media-wrapper]'));
  }

  function changeImage(section, direction) {
    var items = mediaItems(section);
    if (items.length < 2) return;

    var current = items.findIndex(function (item) {
      return !item.classList.contains('hide');
    });
    if (current < 0) current = 0;

    var offset = direction === 'prev' ? -1 : 1;
    var next = (current + offset + items.length) % items.length;
    var mediaId = items[next].getAttribute('data-media-id');
    var thumbnail = section.querySelector('[data-thumbnail-id="' + mediaId + '"]');
    if (thumbnail) thumbnail.click();
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-bedon-gallery-direction]');
    if (!arrow) return;
    var section = arrow.closest('[data-section-type="product"]');
    if (!section) return;
    event.preventDefault();
    event.stopPropagation();
    changeImage(section, arrow.getAttribute('data-bedon-gallery-direction'));
  });

  document.querySelectorAll('[data-product-single-media-group]').forEach(function (gallery) {
    var startX = 0;
    var startY = 0;
    gallery.addEventListener('touchstart', function (event) {
      if (!event.touches.length) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    gallery.addEventListener('touchend', function (event) {
      if (!event.changedTouches.length) return;
      var deltaX = event.changedTouches[0].clientX - startX;
      var deltaY = event.changedTouches[0].clientY - startY;
      if (Math.abs(deltaX) < 50 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      var section = gallery.closest('[data-section-type="product"]');
      if (section) changeImage(section, deltaX > 0 ? 'prev' : 'next');
    }, { passive: true });
  });
})();
